import axios from "axios"
import config from "../config"
import { Progress } from "../entities/Progress"

export const updateProgress = (progress: Progress): Promise<Progress> => {
  return axios
    .put<Progress>(`${config.api}/progress/`, progress)
    .then((response) => response.data)
}
